import React, {Suspense} from 'react'

const LazyComponent = ({children}) => {
    return <Suspense fallback={<div></div>}>
        {children}
    </Suspense>
}

export default LazyComponent
